import script from "./DealModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DealModal.vue?vue&type=script&setup=true&lang=ts"

import "./DealModal.vue?vue&type=style&index=0&id=35ff61de&lang=scss"

const __exports__ = script;

export default __exports__